export function ChatBubble({ role, text, pass, selected, onClick, testId }) {
    const isUser = role === "user";
    const isPending = role === "pending";
    let border = "border-transparent";
    if (pass === true) border = "border-green-500/60";
    if (pass === false) border = "border-red-500/60";
    if (selected) border = "border-laranjinha";
    const pendingMotion = isPending ? "opacity-60 animate-pulse" : "";
    return (
        <div
            className={`flex mb-2 ${isUser ? "justify-end" : "justify-start"} ${pendingMotion}`}
            data-testid={testId}
        >
            <button
                type="button"
                onClick={onClick}
                disabled={!onClick}
                className={`max-w-[80%] rounded px-3 py-2 text-sm text-left border ${border} ${
                    isUser ? "bg-[#d59106] text-black" : "bg-gray-700 text-gray-100"
                } ${onClick ? "cursor-pointer hover:brightness-110" : "cursor-default"}`}
            >
                <p className="text-xs opacity-70 mb-0.5">
                    {isUser ? "Você" : isPending ? "…" : "Bot"}
                </p>
                <p className="whitespace-pre-wrap break-words">
                    {text || (isPending ? "aguardando" : "—")}
                </p>
            </button>
        </div>
    );
}
